import { createSelector } from 'reselect';
import { getCurrentUser } from './getCurrentUser';
import { type ReduxStateShared } from '~shared/types';

const getDateCreated: (state: ReduxStateShared) => string = createSelector(getCurrentUser, (user) => {
  return user?.created_at ? user.created_at : '';
});

export default getDateCreated;
